import React, { useState } from 'react'
import { getAvatar } from '../../utils'

interface AvatarProps {
  className?: any
}
export const Avatar: React.FC<AvatarProps> = (props) => {
  const [failed, setFailed] = useState(false)

  const url = getAvatar()
  const style = {
    width: 40,
    height: 40,
    borderRadius: 20,
    boxShadow: '0 0 6px 0 rgba(163, 101, 0, 0.6)',
    overflow: 'hidden',
    display: 'block'
  }

  if (failed) {
    style.display = 'none'
  }
  return (
    <div style={style} {...props}>
      <img src={url} alt="" style={{ width: '100%' }} onError={() => setFailed(true)} />
    </div>
  )
}

